module.exports = __webpack_public_path__ + "img/fase-2.e58fb638.svg";